import api from '@/utils/axios';

async function postCountryAction(action, payload = {}) {
  try {
    const response = await api.post('countries/manage', { action, ...payload });
    if (!response.data?.success) {
      const error = new Error(response.data?.error?.message || 'Request failed');
      error.code = response.data?.error?.code || null;
      throw error;
    }
    return response.data.data;
  } catch (err) {
    if (err instanceof Error && err.message && !err.response) {
      throw err;
    }
    const message = err?.response?.data?.error?.message || err?.message || 'Request failed';
    const error = new Error(message);
    error.code = err?.response?.data?.error?.code || err?.code || null;
    throw error;
  }
}

export const countriesApi = {
  list: () => postCountryAction('list'),
  create: (payload) => postCountryAction('create', payload),
  update: (payload) => postCountryAction('update', payload),
  delete: ({ country_id }) => postCountryAction('delete', { country_id }),
};
